import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createLastThreadSlice, type LastThreadEntry, type LastThreadSlice } from './slices/createLastThreadSlice';

export const MAX_ENTRIES = 50;

export type LastThreadState = LastThreadSlice;

export const pruneEntries = (entries: Record<string, LastThreadEntry>): Record<string, LastThreadEntry> => {
  const all = Object.entries(entries);
  if (all.length <= MAX_ENTRIES) {
    return entries;
  }
  return Object.fromEntries(all.sort(([, a], [, b]) => b.lastAccessed - a.lastAccessed).slice(0, MAX_ENTRIES));
};

export const useLastThreadStore = create<LastThreadState>()(
  persist(
    (...args) => ({
      ...createLastThreadSlice()(...args),
    }),
    {
      name: 'zustand/ag-ui-chat/last-thread',
      onRehydrateStorage: () => (state) => {
        if (!state) {
          return;
        }
        state.lastThreadByResource = pruneEntries(state.lastThreadByResource);
      },
      partialize: (state) => ({
        lastThreadByResource: state.lastThreadByResource,
      }),
      version: 1,
    },
  ),
);
